import React from 'react';
import MergeOwnersDialog from 'src/components/dialogs/MergeOwnersDialog';
import WhereAttachedDialog from 'src/components/dialogs/WhereAttachedDialog';
import TractListDeltaDialog from 'src/components/project/sections/LeasingComponents/TractListDeltaDialog';
import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import ManageContactCategoriesDialog from 'src/components/project/sections/owners/ManageContactCategoriesDialog';
import ManageOwnerDialog from 'src/components/project/sections/tract/dialogs/ManageOwnerDialog';
import ManageOwnershipDialog from 'src/components/project/sections/tract/dialogs/ManageOwnershipDialog';
import ContactNote from 'src/models/ContactNote';
import IOwner from 'src/models/IOwner';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import { OwnershipLeaseBuyerForm } from 'src/models/OwnershipLeaseBuyer';
import Project from 'src/models/Project';
import ProjectStaff from 'src/models/ProjectStaff';
import PagedResultSet from 'src/models/common/PagedResultSet';
import Ownership from 'src/models/tract_detail/Ownership';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';

export type dialogCreator = {
    mergeOwners: (selectedOwnerId: number, projectData: Project, onNavigate: (path: string) => void, onMerge: () => void) => void;
    manageOwnership: (ownership: Ownership, projectType: 'Mineral' | 'Surface', context: 'Lease Buyers' | 'Contact Categories' | 'Contact Notes', 
                      projectStaff?: PagedResultSet<ProjectStaff>, contactCategories?: OwnershipContactCategoryForm, createNewNote?: boolean, 
                      refreshContainer?: () => void, contactNote?: ContactNote, handleSendList?: (sendList: OwnershipLeaseBuyerForm[]) => void) => void;
    manageOwner: (createOwnership?: boolean, saveAddData?: (values: AddOwnershipData | AddWIOwnershipData | IOwner) => void) => void;
    whereAttached: (ownerId: number) => void;
    manageContactCategories: (ownerships?: Array<Ownership>, onDetach?: () => void) => void;
    tractListDeltaDialog: (isProvisionalOwner: boolean, isEasternStates: boolean, systemTracts: Array<ContractGenerationTractDetail>, formValueTracts: Array<ContractGenerationTractDetail>,
                           updateTractList: () => void) => void;
};

const creators = (setDialog: (element: React.ReactElement) => void): dialogCreator => {
    return {
        mergeOwners: (selectedOwnerId: number, projectData: Project, onNavigate: (path: string) => void, onMerge: () => void) => {
            setDialog(
                React.createElement(MergeOwnersDialog, {
                    selectedOwnerLookupId: selectedOwnerId,
                    projectData: projectData,
                    onMerge,
                    onNavigate: onNavigate
                })
            );
        },
        manageOwnership: (ownership: Ownership, projectType: 'Mineral' | 'Surface', context: 'Lease Buyers' | 'Contact Categories' | 'Contact Notes', 
                          projectStaff?: PagedResultSet<ProjectStaff>, contactCategories?: OwnershipContactCategoryForm, createNewNote?: boolean,
                          refreshContainer?: () => void, contactNote?: ContactNote, handleSendList?: (sendList: OwnershipLeaseBuyerForm[]) => void) => {
            setDialog(
                React.createElement(ManageOwnershipDialog, {
                    ownership,
                    projectStaff,
                    contactCategories,
                    projectType,
                    context,
                    createNewNote,
                    handleSendList,
                    refreshContainer,
                    contactNote    
                })
            );
        },
        whereAttached: (ownerId: number) => {
            setDialog(
                React.createElement(WhereAttachedDialog, {
                    ownerId
                })
            );
        },
        manageOwner: (createOwnership?: boolean, saveAddData?: (values: AddOwnershipData | AddWIOwnershipData | IOwner) => void) => {
            setDialog(
                React.createElement(ManageOwnerDialog, {
                    createOwnership,
                    saveAddData
                })
            );
        },
        manageContactCategories: (ownerships, onDetach?: () => void) => {
            setDialog(
                React.createElement(ManageContactCategoriesDialog, {
                    ownerships,
                    onDetach
                })
            );
        },
        tractListDeltaDialog: (isProvisionalOwner: boolean, isEasternStates: boolean, systemTracts: Array<ContractGenerationTractDetail>, formValueTracts: Array<ContractGenerationTractDetail>,
                               updateTractList: () => void) => {
            setDialog(
                React.createElement(TractListDeltaDialog, {
                    isProvisionalOwner,
                    isEasternStates,
                    systemTracts,
                    formValueTracts,
                    updateTractList
                })
            );
        }
    };
};

export default creators;


// WEBPACK FOOTER //
// ./src/providers/dialogs/owners.ts